export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'https://api.parecer.ai',
  wsUrl: import.meta.env.VITE_WS_URL ?? 'wss://ws.parecer.ai',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
    region: import.meta.env.VITE_COGNITO_REGION ?? 'us-east-1',
  },
  dailyDomain: import.meta.env.VITE_DAILY_DOMAIN ?? 'parecer-ai.daily.co',
};
